import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useSpecificRoleAccess } from "../hooks/useSpecificRoleAccess";

interface SpecificRoleProtectedRouteProps {
  children: ReactNode;
}

const SpecificRoleProtectedRoute: FC<SpecificRoleProtectedRouteProps> = ({
  children,
}) => {
  const { user, loading } = useAuth();
  const { hasAccess, loading: accessLoading } = useSpecificRoleAccess();
  const location = useLocation();

  if (loading || accessLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    // Save the attempted location for redirect after login
    return (
      <Navigate
        to="/authentication/sign-in"
        state={{ from: location }}
        replace
      />
    );
  }

  if (!hasAccess) {
    // User is authenticated but doesn't have specific role access
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default SpecificRoleProtectedRoute;
